import { IApiError } from '@frontend/request';

import { IGetOptionListParams, TOptionChainData } from '@aqx-core/common/api/option';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import optionAPI from '../api';
import { generateOptionChainData } from './dummy';

class OptionAPIController {
  private getOptionListAC?: AbortController;

  public getOptionList = async (
    params: IGetOptionListParams,
    callbacks: IAPIControllerCallbacks<TOptionChainData[]>
  ) => {
    try {
      this.getOptionListAC?.abort();
      this.getOptionListAC = new AbortController();

      let resultData = null;
      if (params?.symbol === 'AAPL') {
        resultData = await generateOptionChainData({
          numArrays: 5,
          symbolName: params.symbol,
          symbolPrice: 225,
          expiration: params.expiration,
          strikesCount: 20,
          strikePriceIncrement: 5
        });
      } else {
        const { result } = await optionAPI.getOptionList(params, this.getOptionListAC.signal);
        resultData = result;
      }

      callbacks.onSuccess(resultData);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const optionAPIController = new OptionAPIController();
